export default __webpack_public_path__ + "static/media/punk.55ec7d0c.gif";